import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RouteConstants} from 'src/app/share/constants/routes.constants';
import { SelectedOrgService } from 'src/app/share/services/selected-org.service';
import { DocumentValutService } from 'src/app/share/document-valut/document-valut.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    standalone: false
})
export class LogoutComponent {
  constructor(
    private readonly router: Router, 
    public activeModal: NgbActiveModal,
    private readonly selectedOrgService: SelectedOrgService,
    private readonly documentValutService: DocumentValutService
  ) {

  }

  logout() {
    this.selectedOrgService.clearAll();
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate([RouteConstants.Login]);
    this.activeModal.close({ status: true });
  }
  closeDialog() {
    this.activeModal.close();
  }
}
